module.exports = __webpack_public_path__ + "media/mypage/images/top/top-agent-pc-a9fcb4f10960dd3066039aef5ecdcd12.jpg";